import React, { useEffect, useState } from "react";
import styles from "./Business.module.scss";
import { ReactComponent as CloseIcon } from "../../../assets/images/Icons/closenew.svg";
import { Divider } from "antd";
import { openToastAndSetContent } from "../../../redux/actions/toast/toastActions";
import client from "../../../api/client";
import { ToastErrorStyles } from "../../../constants/toastStyles";
import { useDispatch } from "react-redux";
import {
  closeLoader,
  openLoader,
} from "../../../redux/actions/loader/loaderActions";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Chip,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { camelToTitle } from "../../../utils/commonHelper";
import dayjs from "dayjs";

function ViewDetails({ closeModal, openState, id }: any) {
  interface MerchantData {
    registrationNumber: string;
    registrationDate: string;
    email: string;
    officeAddress: string;
    state: string;
    lga: string;
    city: string;
    companyStatus: string;
  }
  interface MerchantInfo {
    data: MerchantData;
    keyPersonnel: any[];
  }
  const [isLoading, setIsLoading] = useState(false);
  const [businessDetails, setBusinessDetails] = React.useState<MerchantInfo>();

  const dispatch = useDispatch();

  const getDetails = () => {
    dispatch(openLoader());
    setIsLoading(true);
    client
      .get(`/business/kyc/fetch/${166}`)
      .then((data: any) => {
        setBusinessDetails({
          data: {
            registrationNumber: data?.data?.registrationNumber,
            registrationDate: dayjs(data?.data?.registrationDate).format(
              "YYYY-MM-DD 23:59:59"
            ),
            email: data?.data?.email,
            officeAddress: data?.data?.headOfficeAddress,
            state: data?.data?.state,
            lga: data?.data?.lga,
            city: data?.data?.city,
            companyStatus: data?.data?.companyStatus,
          },
          keyPersonnel: data?.data?.keyPersonnel,
        });

        dispatch(closeLoader());
        setIsLoading(false);
      })
      .catch((error: any) => {
        dispatch(closeLoader());
        setIsLoading(false);

        const message = error?.response?.data?.message;

        dispatch(
          openToastAndSetContent({
            toastContent: message,
            toastStyles: ToastErrorStyles,
          })
        );
      });
  };

  useEffect(() => {
    //trigger details endpoint
    openState && id && getDetails();
  }, [id]);

  return (
    <div>
      {!isLoading && (
        <>
          <div className={styles.viewDetailModalhead}>
            <Typography
              variant='subtitle1'
              style={{ margin: 0, paddingLeft: 0 }}
              sx={{ fontWeight: 600 }}
            >
              MERCHANT INFORMATION
            </Typography>
            <CloseIcon onClick={closeModal} style={{ cursor: "pointer" }} />
          </div>
          <Divider style={{ margin: 0, padding: 0 }} />
          <div className={styles.viewDetailModalcontent}>
            <Grid container spacing={2}>
              {businessDetails?.data &&
                typeof businessDetails?.data === "object" &&
                Object.keys(businessDetails?.data).length > 0 &&
                Object.entries(businessDetails?.data).map(
                  ([key, value]: any) => (
                    <Grid item xs={12} sm={6} md={6} lg={6} key={key}>
                      <div>
                        <Typography
                          variant='subtitle2'
                          // color='textSecondary'
                          sx={{ fontWeight: 600, fontSize: "0.9rem", mb: 0.5 }}
                        >
                          <strong> {camelToTitle(key)}</strong>
                        </Typography>
                        <Typography variant='body2' sx={{ fontSize: "0.9rem" }}>
                          {value !== undefined && value !== null && value !== ""
                            ? String(value)
                            : "Not Provided"}
                        </Typography>
                      </div>
                    </Grid>
                  )
                )}
            </Grid>
          </div>
          <Divider style={{ margin: 0, padding: 0, paddingBottom: 18 }} />

          <Typography
            variant='subtitle1'
            style={{ margin: 0, paddingLeft: 15, paddingBottom: 18 }}
            sx={{ fontWeight: 600 }}
          >
            KEY PERSONNEL
          </Typography>

          <div>
            {businessDetails?.keyPersonnel &&
              businessDetails?.keyPersonnel.map((person, index) => (
                <Accordion key={index}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel${index}-content`}
                    id={`panel${index}-header`}
                  >
                    <Typography variant='subtitle2' sx={{ fontWeight: 600 }}>
                      {person.name || "Not Provided"}
                    </Typography>
                    {person?.status && (
                      <Chip
                        label={person?.status}
                        size='small'
                        color={
                          person?.status === "ACTIVE" ? "success" : "default"
                        }
                        sx={{ ml: 2 }}
                      />
                    )}
                  </AccordionSummary>

                  <AccordionDetails>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Typography variant='body2'>
                          <strong>Designation:</strong>{" "}
                          {person?.designation || "Not Provided"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant='body2'>
                          <strong>Date of Birth:</strong>{" "}
                          {person?.dateOfBirth
                            ? // ? dayjs(person?.dateOfBirth).format("DD/MM/YYYY")
                              dayjs(person?.dateOfBirth).format(
                                "YYYY-MM-DD 23:59:59"
                              )
                            : "Not Provided"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant='body2'>
                          <strong>Gender:</strong>{" "}
                          {person.gender || "Not Provided"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant='body2'>
                          <strong>Address:</strong>{" "}
                          {person.address || "Not Provided"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant='body2'>
                          <strong>Email:</strong>{" "}
                          {person.email || "Not Provided"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant='body2'>
                          <strong>Phone:</strong>{" "}
                          {person.phone || "Not Provided"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant='body2'>
                          <strong>Share Value:</strong>{" "}
                          {person.sharesValue || "Not Provided"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              ))}
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginBottom: "16px",
              paddingTop: "20px",
            }}
          >
            <Button variant='outlined' color='inherit' onClick={closeModal}>
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );
}

export default ViewDetails;
